import { IApplicationState, TBoardId } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getMyWorkSelectedBoards = (
    state: IApplicationState
): TBoardId[] => {
    return getAuthUserMetaMyWork(state).selectedBoards || [];
};
